import 'stylesheets/front.scss'
import 'javascripts/front'